module.exports = __webpack_public_path__ + "assets/airbag-system.b9a93153.svg";